import { render, staticRenderFns } from "./customizationMainSection.vue?vue&type=template&id=f250217e"
import script from "./customizationMainSection.vue?vue&type=script&lang=js"
export * from "./customizationMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports